(ns frontend.ux-overhaul.listing.pipeline-entity.card-style
  "The look of a card on the Kanban of a pipeline entity type, from the status of
   its entity. The old Kanban showed a passed deal with a red border. The tone of
   each status is in `common.pipeline-status-actions`, one table for the four
   pipeline entity types. The status of the card is the status bar of
   `ui.components.card.kanban`."
  (:require
   [common.pipeline-status-actions :as pipeline-status-actions]))

(def tone-statuses
  {:negative :lost
   :caution  :on-track})

(defn status-fn
  "Return a function from a card to the status of the card: `:lost` for a
   negative tone and `:on-track` for a caution tone. The function returns nil
   when the status has no tone, so that the card keeps its default status bar."
  [entity-type]
  (fn [card]
    (some->> (pipeline-status-actions/row-status entity-type card)
             (pipeline-status-actions/status-tone entity-type)
             (get tone-statuses))))
